/** @jsx jsx */

import { jsx } from '@emotion/core';

import { Select, SelectItem } from '@zapier/design-system';

import type { SemVer } from 'app/developer-v3/types/version';

type Props = {
  onChange: (value: SemVer) => void;
  size: 'compact' | 'medium';
  version: SemVer;
  versions: SemVer[];
};

function VersionDropdown(props: Props) {
  const { onChange, size, version, versions } = props;

  return (
    <Select
      isLabelHidden={true}
      label="Version"
      onChange={key => onChange(key as SemVer)}
      placeholder="Choose a version"
      selectedKey={version}
      size={size}
    >
      {versions.map(v => (
        <SelectItem key={v} value={v}>{`Version ${v}`}</SelectItem>
      ))}
    </Select>
  );
}

VersionDropdown.defaultProps = {
  size: 'compact',
};

export default VersionDropdown;
